import { getCoworkerPreferences } from '@repo/api-adapters/coworker-preferences';
import { useQuery } from '@tanstack/react-query';

import { API } from './utils.api';

export interface UseCoworkerPreferencesQueryOptions {
    enabled?: boolean;
    retry?: boolean | number | ((failureCount: number, error: Error) => boolean);
    retryDelay?: number | ((failureCount: number, error: Error) => number);
}

export const useCoworkerPreferencesQuery = (
    coworkerPreferencesBasePath: string,
    options?: UseCoworkerPreferencesQueryOptions
) => {
    return useQuery({
        queryKey: [API.coworkerPreferences, coworkerPreferencesBasePath],
        queryFn: () => getCoworkerPreferences(coworkerPreferencesBasePath),
        enabled: options?.enabled ?? true,
        ...(options?.retry === undefined ? {} : { retry: options.retry }),
        ...(options?.retryDelay === undefined ? {} : { retryDelay: options.retryDelay }),
        staleTime: Infinity,
    });
};
